import { OrganizationsService } from 'app/API';
import type { TAttorneysTransactionsListParams } from 'app/queries/attorneys/attorneysKeys';
import type { TCall } from 'app/queries/types/TCall';
import { buildAttorneysTransactionsRequest } from './buildAttorneysTransactionsRequest';

export const fetchAllAttorneysTransactionsForExport = async (
  call: TCall,
  organizationId: string,
  params: TAttorneysTransactionsListParams,
) => {
  const baseExportParams = {
    ...buildAttorneysTransactionsRequest(organizationId, { ...params, search: '' }),
    skip: 0,
  };
  const countResponse = await call(() =>
    OrganizationsService.getAllAttorneysTransactions({ ...baseExportParams, limit: 1 }),
  );

  if (countResponse.count === 0) {
    return countResponse;
  }

  return call(() =>
    OrganizationsService.getAllAttorneysTransactions({ ...baseExportParams, limit: countResponse.count }),
  );
};
